import * as React from 'react';

import { useClearDiagram } from 'src/containers/ProjectDiagram/hooks/useClearDiagram';
import { useDiagram } from 'src/containers/ProjectDiagram/hooks/useDiagramValue';
import { ExtendedDiagram } from 'src/containers/ProjectDiagram/templates/extensions/diagram';
import { commitDiagramModel } from 'src/containers/ProjectDiagram/utils/commitDiagramModel';
import { removeModelConceptAttribute } from 'src/containers/ProjectDiagram/utils/modelConceptAttribute/removeModelConceptAttribute';
import { uiSlice } from 'src/store/ui/ui.slice';
import { useReduxDispatch } from 'src/utils/hooks/useReduxDispatch';
import { useRouterParams } from 'src/utils/hooks/useRouterParams';

export const useRemoveModelConceptAttribute = () => {
  const { projectId } = useRouterParams();
  const diagram = useDiagram();
  const clearDiagram = useClearDiagram();
  const dispatch = useReduxDispatch();

  return React.useCallback(
    async ({
      attributeIri,
      diagram: commitDiagram,
    }: {
      attributeIri: string;
      diagram?: ExtendedDiagram;
    }) => {
      const diagramToUse = commitDiagram || diagram;
      if (!diagramToUse) {
        return;
      }
      clearDiagram();

      const didCommit = await commitDiagramModel(
        diagramToUse,
        removeModelConceptAttribute({
          value: attributeIri,
        }),
        { shouldCommit: !commitDiagram }
      );

      if (didCommit) {
        dispatch(
          uiSlice.actions.removedKeysFromEntityDrawerHistory({
            projectId,
            entityValues: [attributeIri],
          })
        );
      }
    },
    [clearDiagram, diagram, dispatch, projectId]
  );
};
